import axios from '../axios'

/*
 * 數據模塊
 */
//分页获取远程影像中心列表
// export const getImageList = (data) => {
//   return axios({
//     url: '/cloud_service/fileRes/load',
//     method: 'post',
//     params: data
//   })
// };
// //上传云端
// export const uploadCloud = (data) => {
//   return axios({
//     url: '/cloud_service/Cloud/apply',
//     method: 'get',
//     params: data
//   })
// };
//获取侧边栏
export const getMenuList = (data) => {
    return axios({
		url: '/api/sys/menu/nav',
		method: 'get',
		params: data
    })
};


// WEBPACK FOOTER //
// ./src/http/moudules/menu.js